import Box from '@mui/material/Box';


function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    const isDataGridTab = (typeof index !== 'undefined' && index !== null);
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        style={
          isDataGridTab
            ? { display: 'block', 
                position: value === index ? 'relative' : 'absolute',
                visibility: value === index ? 'visible' : 'hidden', 
                minHeight: 500, 
                height: 700 
          } // Keep mounted
            : {
              display: 'block', 
              position: 'relative', 
              visibility: value === index ? 'visible' : 'hidden',
              height: 10
          } // Default behavior for others
        }
        {...other}
      >
        <Box sx={{ p: 3, height: 500, padding: '0px 20px 0px 20px', display: 'block', visibility: value === index ? 'visible' : 'hidden' }}>
            {children}
        </Box>
      </div>
    );
}

export default CustomTabPanel